import styled from 'styled-components'

import {
  mainColors,
  rgba,
  shadowColors,
  TextFieldInputContainer,
  zIndex,
} from '@avantstay/backoffice-core'

export const Wrapper = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;

  > * {
    ${TextFieldInputContainer} {
      border-width: 0 0 1px 0;
    }
  }
`

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 560px;
  padding: 12px;
  background: ${mainColors.white};
  border: 1px solid ${mainColors.neutralLight};
  border-radius: 2px;
  box-shadow: 0 4px 16px ${rgba(shadowColors.blur, 0.4)};
  overflow-y: auto;
  outline: none;
  z-index: ${zIndex.MODAL};
`
